import * as types from "./dadosCadastrais.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";

export default {
  saveContadorContribuinte: () => ({
    type: types.SAVE_CONTADOR_CONTRIBUINTE,
  }),
  setDadosCadastrais: (data) => ({
    type: types.DADOSCADASTRAIS_SET,
    payload: data,
  }),
  setContadorContribuinte: (data) => ({
    type: types.SET_CONTADOR_CONTRIBUINTE,
    payload: data,
  }),
  dadosCadastraisResetForm: () => ({
    type: types.DADOSCADASTRAIS_RESETFORM,
  }),
  resetForm: () => ({
    type: commonActionType.RESET,
  }),
  getSuggestionContador: (contador) => ({
    type: types.GET_SUGGESTION_CONTADOR,
    payload: contador,
  }),
  getDataNascimentoCadastral: (name, dados, date) => ({
    type: types.GET_DATA_NASCIMENTO_CADASTRAL,
    payload: { name, dados, date },
  }),
  getDataOcorrencia: (name, dados, date) => ({
    type: types.GET_DATA_OCORRENCIA,
    payload: { name, dados, date },
  }),
  getDataAberturaCadastral: (name, dados, date) => ({
    type: types.GET_DATA_ABERTURA_CADASTRAL,
    payload: { name, dados, date },
  }),
  openModalContador: (data) => ({
    type: types.OPEN_MODAL_CONTADOR,
    payload: data,
  }),
  resetContadorContribuinte: () => ({
    type: types.RESET_CONTADOR_CONTRIBUINTE,
  }),
  resetDataAberturaCadastral: () => ({
    type: types.RESET_DATA_ABERTURA_CADASTRAL,
  }),
  resetDataOcorrencia: () => ({
    type: types.RESET_DATA_OCORRENCIA,
  }),
};
